import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html{
        scroll-behavior: smooth;
    }

    body {
        font-family: 'Manrope', sans-serif;
        background: ${({ theme }) => theme.colors.background};
        color: ${({ theme }) => theme.colors.text};
        overflow-x: hidden;
    }

    a{
        text-decoration: none;
        color: inherit;
    }

    button{
        font-family: inherit;
    }
`;

export default GlobalStyle;